export default function CampaignModel(dict) {
    if (dict.CampaignId) {
        this.id = dict.CampaignId;
    }
    this.details = dict.Details
    this.detailKey = dict.DetailKey
    this.discount = dict.Discount
    this.discountType = dict.DiscountType
    this.expireDate = dict.ExpireDate
    this.imageUrl = dict.ImageUrl
    this.name = dict.Name
    this.barcode = 'QR_CODE';
    this.detail = dict.Detail;
    this.condition = dict.Condition;

    this.fullImageUrl = this.imageUrl;
    if (this.fullImageUrl) {
        if (this.fullImageUrl.indexOf("-large") < 0) {
            var newString = this.fullImageUrl.replace("?", "-large?");
            this.fullImageUrl = newString;
        }
    }

    this.updateAfterRedeem = function (dict) {
        this.serial = dict.OVSCode;
        this.expireIn = dict.ExpireIn;
        this.redeemDate = dict.Timestamp;
        this.isUsed = dict.IsUsed;
    }    
}